import React from "react";
import { ProseContainer } from "./Prose.styled";
export const Prose: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  return <ProseContainer data-sentry-element="ProseContainer" data-sentry-component="Prose" data-sentry-source-file="index.tsx">{children}</ProseContainer>;
};